import React from 'react'
import Iframe from 'react-iframe'

const ViewMail = () => {
  return (


    <div className="">
    <h1 className="text-primary-red mt-2 top-9 text-center text-3xl font-bold lg:!mt-6">
   <a href="https://s303.bom7.mysecurecloudhost.com:2096/cpsess3249308502/3rdparty/roundcube/?_task=mail&_mbox=INBOX" target="_blank" className='text-center m-auto text-primary-blue'>Click  Here for View Mail</a>

    </h1>
    <div className="">
      <img
        src="../../images/title-border.png"
        alt=""
        className="mx-auto mt-4"
      />
    </div>
    {/* iframe */}
    <div className="">
      {/* <iframe src="http://www.proxy-service.com/https://ocr.gov.np/" width={540} height={450}></iframe> */}
      {/* <div dangerouslySetInnerHTML={ iframe} /> */}
      {/* <Iframe
       url="https://s303.bom7.mysecurecloudhost.com:2096/cpsess3249308502/3rdparty/roundcube/?_task=mail&_mbox=INBOX/"
      height="500px"
      id=""
      className="w-full"
      display="block"
      position="relative"/> */}


    </div>

  </div>
  )
}

export default ViewMail
